import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components/macro'
import AuthForm from 'components/molecules/auth-form'
import { AuthFormTypeEnum } from 'config/enums'

const Container = styled.div`
  width: 100%;
`

const StyledAuthForm = styled(AuthForm)`
  box-shadow: ${({ theme }) => theme.shadows.bottom};
  background-color: ${({ theme }) => theme.colors.brandGolf};
  padding: ${({ theme }) => theme.sizings.lvl3};
`

function ResetPasswordForm({ error, feedback, onSubmit }) {
  const { t } = useTranslation()

  const fields = [
    {
      errorText: t('password'),
      name: 'password',
      title: t('password'),
      type: 'password',
      validator: (values, index) =>
        values[index].length < 1 && t('passwordRequired'),
    },
    {
      name: 'passwordRepeat',
      title: t('passwordRepeat'),
      type: 'password',
      validator: (values, index) => {
        if (values[index].length < 1) {
          return t('passwordRequired')
        }
        return values[index] !== values[0] && t('passwordRepeatDoesntMatch')
      },
    },
  ]

  return (
    <Container>
      <StyledAuthForm
        error={error}
        feedback={feedback}
        fields={fields}
        onSubmit={onSubmit}
        submitText={t('resetPassword')}
        title={t('recoverPassword')}
        formType={AuthFormTypeEnum.RESET_PASSWORD}
      />
    </Container>
  )
}

ResetPasswordForm.propTypes = {
  error: PropTypes.string,
  feedback: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.bool,
    PropTypes.node,
  ]),
  onSubmit: PropTypes.func.isRequired,
}

ResetPasswordForm.defaultProps = {
  error: null,
  feedback: null,
}

export default ResetPasswordForm
